
export const classNames = (...classes: (null|undefined|boolean|string)[]) =>
  classes.filter(Boolean).join(" ");
